// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__nuUfx","icon":"Header_icon__Xub9+","span":"Header_span__RcMI0"};